import { env } from "../env/config";
import { IStorage } from "./interface";

export const getAuthToken = () => {
    const o = localStorage.getItem(env.key_storage);
    if (!o) {
        return null
    }
    return JSON.parse(o).accessToken//'{"accessToken":1}' // localStorage.getItem(env.key_storage);
}

export const getAuthTokenSync = async () => {
    return localStorage.getItem(env.key_storage);
}

export const setAuthToken = (value: IStorage) => {
    localStorage.setItem(env.key_storage, JSON.stringify(value));
};

export const removeAuthToken = () => {
    localStorage.removeItem(env.key_storage);
};